import { render, staticRenderFns } from "./GenericWords.vue?vue&type=template&id=20d60e2e&lang=pug&"
import script from "./GenericWords.vue?vue&type=script&lang=js&"
export * from "./GenericWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports